import { useEffect, useState } from 'react'
import { colors } from '../colors'
import heartIcon from '../images/loginBenefits/heart.png'
import postIcon from '../images/loginBenefits/post.png'
import shopIcon from '../images/loginBenefits/shop.png'

interface LoginModalProps {
  isOpen: boolean
  onClose: () => void
}

const styles: Record<string, React.CSSProperties> = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
  },
  modal: {
    backgroundColor: colors['keijiban-coral-bg'],
    borderRadius: '12px',
    padding: '32px 20px 16px',
    maxWidth: '360px',
    width: '90%',
    position: 'relative',
  },
  closeButton: {
    position: 'absolute',
    top: '16px',
    right: '16px',
    background: 'none',
    border: 'none',
    fontSize: '24px',
    color: '#666666',
    cursor: 'pointer',
    padding: '0',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontSize: '18px',
    fontWeight: 'bold',
    textAlign: 'center',
    lineHeight: '1.2',
    color: '#333333',
    marginBottom: '0',
  },
  loginBenefits: {
    margin: '16px 0 0',
    fontSize: '14px',
    listStyle: 'none',
    padding: '0',
  },
  loginBenefitsItem: {
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    fontSize: '14px',
    lineHeight: '1.4',
    padding: '8px 0',
  },
  loginBenefitsText: {
    margin: 0,
    fontSize: '12px',
    color: colors['keijiban-brown'],
  },
  buttonContainer: {
    marginTop: '8px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  loginButton: {
    display: 'block',
    width: '100%',
    padding: '12px',
    backgroundColor: colors['keijiban-coral'],
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '9999px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    textDecoration: 'none',
    textAlign: 'center',
  },
  laterButton: {
    display: 'block',
    width: '100%',
    padding: '12px',
    color: colors['text-secondary'],
    backgroundColor: 'transparent',
    border: 'none',
    fontSize: '14px',
    fontWeight: 'normal',
    cursor: 'pointer',
    textAlign: 'center',
  },
}

const LoginModal: React.FC<LoginModalProps> = ({ isOpen, onClose }) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    }
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [isOpen])

  if (!mounted || !isOpen) return null

  const currentUrl = encodeURIComponent(window.location.href)
  const loginUrl = `/sessions/login_tokubai?rt=${currentUrl}`

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <button type="button" style={styles.closeButton} onClick={onClose} aria-label="閉じる">
          ×
        </button>
        
        <h2 style={styles.title}>
          ログインして<br />
          あなたの「おいしい！」を<br />
          シェアしませんか？
        </h2>

        <ul style={styles.loginBenefits}>
          <li
            style={{
              ...styles.loginBenefitsItem,
              borderBottom: `1px solid ${colors['border-light']}`,
            }}
          >
            <img src={postIcon} alt="口コミの投稿" width={80} height={80} />
            <p style={styles.loginBenefitsText}>“おいしい”口コミを投稿して、みんなにシェアする</p>
          </li>
          <li
            style={{
              ...styles.loginBenefitsItem,
              borderBottom: `1px solid ${colors['border-light']}`,
            }}
          >
            <img src={shopIcon} alt="フォロー中のお店の投稿を絞り込む" width={80} height={80} />
            <p style={styles.loginBenefitsText}>お気に入りのお店をフォローして、話題の商品をチェック</p>
          </li>
          <li style={styles.loginBenefitsItem}>
            <img src={heartIcon} alt="気になる投稿へのリアクション" width={80} height={80} />
            <p style={styles.loginBenefitsText}>「食べたい！」「わかる！」をリアクションで伝える</p>
          </li>
        </ul>

        <div style={styles.buttonContainer}>
          <a href={loginUrl} style={styles.loginButton}>
            ログイン・新規登録
          </a>
          <button type="button" style={styles.laterButton} onClick={onClose}>
            今はしない
          </button>
        </div>

      </div>
    </div>
  )
}

export default LoginModal
